// Keelis Assets
// import logo from "../assest/LogoAndFavicon/keelislogo.png";
// import favicon from "../assest/LogoAndFavicon/favicon/keelisfavicon.png";

//Eg Assests
import logo from "../assest/LogoAndFavicon/evergaurdlogonew.png";
import favicon from "../assest/LogoAndFavicon/favicon/egfavicon.ico";

// *********************Keelis Assets*******************************************************

// Development;
// const assets = {
//   logo: logo,
//   favicon: favicon,
//   company: "Keelis",
//   actualname: "Keel Info Solution Private Limited",
//   baseurl: "https://hrmsbk.keelisdev.in/graphql/",
//   mediaurl: "https://hrmsbk.keelisdev.in/media",
//   pdfurl: "https://hrmsbk.keelisdev.in/media/",
//   loginname: "Keelis",
// };

// Testing;
// const assets = {
//   logo: logo,
//   favicon: favicon,
//   company: "Keelis",
//   actualname: "Keel Info Solution Private Limited",
//   baseurl: "https://hrmstestbk.keelistest.in/graphql/",
//   mediaurl: "https://hrmstestbk.keelistest.in/media",
//   pdfurl: "https://hrmstestbk.keelistest.in/media/",
//   loginname: "Keelis",
// };

//live

// const assets = {
//   logo: logo,
//   favicon: favicon,
//   company: "Keelis",
//   actualname: "Keel Info Solution Private Limited",
//   baseurl: "https://hrmsdbdemobk.keelis.in/graphql/",
//   mediaurl: "https://hrmsdbdemobk.keelis.in/media",
//   pdfurl: "https://hrmsdbdemobk.keelis.in/media/",
//   loginname: "Keelis",
// };

// *****************************EG Assets**********************************************

//Development
// const assets = {
//   logo: logo,
//   favicon: favicon,
//   company: "Eg",
//   actualname: "EverGuard Insurance Broking Services Private Limited",
//   baseurl: " https://eghrmsbk.keelisdev.in/graphql/",
//   mediaurl: " https://eghrmsbk.keelisdev.in/media",
//   pdfurl: " https://eghrmsbk.keelisdev.in/media/",
//   loginname: "EverGuard",
// };

//test
// const assets = {
//   logo:logo,
//   favicon:favicon,
//   company :'Eg',
//   actualname:"EverGuard Insurance Broking Services Private Limited",
//   baseurl:" https://eghrmsbk.keelistest.in/graphql/",
//   mediaurl:" https://eghrmsbk.keelistest.in/media",
//   pdfurl:' https://eghrmsbk.keelistest.in/media/',

//   loginname:'EverGuard'
// };

// //test new
// const  assets ={                                                                                                                    assets = {
//   logo:logo,
//   favicon:favicon,
//   company :'Eg',
//   actualname:"EverGaurd Insurance Broking Services Private Limited",
//   baseurl:"http://www.eghrmsnewbk.keelistest.in/graphql/",
//   mediaurl:"http://www.eghrmsnewbk.keelistest.in/media",
//   pdfurl:'http://www.eghrmsnewbk.keelistest.in/media/',

//   loginname:'Ever Guardian'
// };

//Live

const assets = {
  logo: logo,
  favicon: favicon,
  company: "Eg",
  actualname: "EverGuard Insurance Broking Services Private Limited",
  baseurl: "https://hrmsbk.egtech.in/graphql/",
  mediaurl: "https://hrmsbk.egtech.in/media",
  pdfurl: "https://hrmsbk.egtech.in/media/",
  loginname: "EverGuard",
};

export default assets;
